module.exports = __webpack_public_path__ + "static/media/barcelove.c0681434.png";